import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import * as _ from 'lodash';

import { AuthService } from 'src/app/services/auth.service';
import { default as data } from 'src/assets/data/countries.json';
import { default as codes } from 'src/assets/data/country-codes.json';
import SignUpResponse from 'src/app/interfaces/auth/SignUpResponse';

@Component({
  selector: 'app-signup',
  templateUrl: './signup.component.html',
  styleUrls: ['./signup.component.scss']
})
export class SignupComponent implements OnInit {

  public states: any = [];
  public countries: any = data;
  public gender: any = [{ name: 'Male', label: 'M' }, { name: 'Female', label: 'F' }, { name: 'Others', label: 'O' }];
  public title: any = ['Mr', 'Ms', 'Mrs', 'Dr'];
  public signupForm: FormGroup;
  public publicKey: any;
  public submitted: boolean = false;
  public confirmPassword: string = '';
  public isNotMatched: boolean = false;
  public isAgree: boolean = false;
  public isSignUpSuccess: boolean = false;
  public type: any = 'text';
  constructor(private authService: AuthService, private toastrService: ToastrService, private router: Router, private http: HttpClient) { }

  ngOnInit(): void {
    this.authService.getPublicKey().subscribe(
      (res: any) => {
        this.publicKey = res.key;
      }
    )
    this.signupForm = new FormGroup({
      title: new FormControl('', Validators.required),
      firstName: new FormControl('', Validators.required),
      lastName: new FormControl('', Validators.required),
      dob: new FormControl('', Validators.required),
      countryCode: new FormControl('', Validators.required),
      phone: new FormControl('', Validators.required),
      qualification: new FormControl('', Validators.required),
      state: new FormControl('', Validators.required),
      country: new FormControl('', Validators.required),
      pincode: new FormControl('', Validators.required),
      address: new FormControl('', Validators.required),
      email: new FormControl('', Validators.required),
      password: new FormControl('', Validators.required),
      institution: new FormControl('', Validators.required),
      gender: new FormControl('', Validators.required)
    })
  }

  onClickDate(event) {
    if (this.type !== 'date') {
      this.type = 'date';
    }
  }

  async onSignUp() {
    try {
      this.submitted = true;
      if (this.signupForm.valid && !this.isNotMatched && this.confirmPassword) {
        const payload = _.get(this.signupForm, 'value');
        const response: SignUpResponse = await this.authService.signUp(payload).toPromise();
        this.toastrService.success(response.message);
      }
    }
    catch (err) {
      this.toastrService.error(err?.error?.message || err.message || "Something went wrong, this should never happen");
    }

  }

  onSelectCountry() {
    for (let i = 0; i < data['data'].length; i++) {
      if (data.data[i].name == this.signupForm.get('country').value) {
        this.states = data.data[i].states;
        break;
      }
    }
    for (let i = 0; i < codes.length; i++) {
      if (codes[i].name == this.signupForm.get('country').value) {
        this.signupForm.get('countryCode').setValue(codes[i].dial_code);
        break;
      }
    }
  }

  passwordCheck(event) {
    if (event !== this.signupForm.get('password').value) {
      this.isNotMatched = true;
      this.confirmPassword = event;
    }
    else {
      this.isNotMatched = false;
      this.confirmPassword = event;
    }
  }
}
